import 'intersection-observer';
import 'picturefill';
import objectFitImages from 'object-fit-images';
import app from './app/app'
import pageHeader from './app/component/pageHeader';
import pageHeaderCompact from './app/component/pageHeaderCompact';
import page from './app/component/page';
import primaryBanner from './app/component/primaryBanner';
import primaryBannerSwipe from './app/component/primaryBannerSwipe';
import homeBrandList from './app/component/homeBrandList';
import contentList from './app/component/contentEntry';
import eventList from './app/component/eventEntry';
import svg4everybody from 'svg4everybody';
import tab from './app/component/crossFadeTab';
import accordion from './app/component/accordion';
import scrollAnchor from './app/component/scrollAnchor';
import userLinkSwitch from './app/component/userLinkSwitch';
import facebookShare from './app/component/facebookShare';
import twitterShare from './app/component/twitterShare';
import pageTop from './app/component/pageTop';
import lineShare from './app/component/lineShare';
import movieHero from './app/component/movieHero';
import recommendSlider from './app/component/recommendSlider';
import homeEvent from './app/component/homeEvent';
import * as mediaQuery from './app/mediaQuery';
import Router from './app/router';
import splash from './app/component/splash';
import homeTopics from './app/component/homeTopics';
import readMore from './app/component/readMore';
import { windowLoadAction } from './app/action/windowLoadAction';
import headerLink from './app/component/headerLink';

svg4everybody();


document.addEventListener('DOMContentLoaded', () => {

  const router = new Router();


  app.registerComponent('pageHeader', '.js-pageHeader', pageHeader);
  app.registerComponent('pageHeaderCompact', '.js-pageHeaderCompact', pageHeaderCompact);
  app.registerComponent('page', '#page', page);
  app.registerComponent('fs-page', '#FS2_layout_body', page);

  app.registerComponent('homeBrandList', '.js-homeBrandList', homeBrandList);
  app.registerComponent('tabify', '.js-tab', tab);
  app.registerComponent('readMore', '.js-readMore', readMore);

  app.registerComponent('accordion', '.js-accordion', accordion, {
    duration: 0.7
  });

  app.registerComponent('scrollAnchor', 'a[href^="#"]', scrollAnchor);

  app.registerComponent('userLinkSwitch', '.js-userLinkSwitch', userLinkSwitch);
  app.registerComponent('facebookShare', '.js-facebookShare', facebookShare);
  app.registerComponent('twitterShare', '.js-twitterShare', twitterShare);
  app.registerComponent('lineShare', '.js-lineShare', lineShare);
  app.registerComponent('pageTop', '.js-pageTop', pageTop);

  app.registerComponent('recommendSlider', '.js-homeRecommend', recommendSlider);

  app.registerComponent('contentList', '.js-contentList', contentList);
  app.registerComponent('eventList', '.js-eventList', eventList);


  app.registerComponent('moveHero', '.js-movieHero', movieHero, {
    defaultSrc: '/assets/images/home/mv_pc.mp4',
    srcSet: [
      {
        mediaQuery: '(min-width: 834px)',
        src: '/assets/images/home/mv_pc.mp4'
      },
      {
        mediaQuery: '(max-width: 833px)',
        src: '/assets/images/home/mv_sp.mp4'

      }
    ]
  });

  app.registerComponent('moveHeroPrimary--guitar', '.js-movieItemCtgPrimary--guitar', movieHero, {
    defaultSrc: '/assets/images/home/bg_cat_guitar_mov.mp4',
  });

  app.registerComponent('moveHeroPrimary--bass', '.js-movieItemCtgPrimary--bass', movieHero, {
    defaultSrc: '/assets/images/home/bg_cat_bass_mov.mp4',
  });

  router.route('(/|/index.html|index.php)', (path, token, router) => {
    app.registerComponent('renewalSplash', '.js-splash', splash);
    app.registerComponent('homeEvent', '.js-homeEvent', homeEvent);
    app.registerComponent('homeTopics', '.js-homeTopics', homeTopics);
  });

  const narrowQueryMatched = (mql) => {

    if(!mql.matches) {
      return;
    }

    app.unregisterComponent('headerLink');
    app.unregisterComponent('primaryBanner');
    app.registerComponent('brandListAccordion', '.js-blandListAccordion', accordion, {
      control: '.js-blandListAccordion__head',
      body: '.js-blandListAccordion__body',
      state: 'collapsed'
    });

    app.registerComponent('primaryBannerSwipe', '.js-primaryBanner', primaryBannerSwipe);
    app.registerComponent('headerLink', '.js-headerLinkCompact', headerLink);
  };

  const wideQueryMatched = (mql) => {

    if(!mql.matches) {
      return;
    }

    app.unregisterComponent('headerLink');
    app.unregisterComponent('primaryBannerSwipe');
    app.unregisterComponent('brandListAccordion');

    app.registerComponent('primaryBanner', '.js-primaryBanner', primaryBanner);
    app.registerComponent('headerLink', '.js-headerLink', headerLink);
  };

  mediaQuery.wideMediaQuery.addListener(wideQueryMatched);
  mediaQuery.narrowMediaQuery.addListener(narrowQueryMatched);

  mediaQuery.wideMediaQuery.matches && wideQueryMatched(mediaQuery.wideMediaQuery);
  mediaQuery.narrowMediaQuery.matches && narrowQueryMatched(mediaQuery.narrowMediaQuery);


  router.exec(location.pathname);

  objectFitImages(null, { watchMQ:true });


  window.addEventListener('load', () => {
    app.channel.sendDownstream(windowLoadAction);
  });

  window.addEventListener('unload', () => {

  });
});





// WEBPACK FOOTER //
// ./src/js/entry.js